import { tcConfigUserEventCollectorUrl } from "./globalConfig";
import { userIsWebCrawler } from "@theconversation/shared-components/tcEventsCollector";
const eventQueue = [];
const BATCH_WAIT_TIME_MS = 100;
const MAX_BATCH_SIZE = 15;
let endOfSessionDispatcherCreated = false;
/*
  Public function to send an event.
  Unless the "immediate" flag is set, the event is held in a queue for a short
  period, in the hope that other events can be collected and then sent as a single batch.
*/
export function dispatchEvent(event, immediate = false) {
    if (userIsWebCrawler())
        return;
    eventQueue.push(event);
    ensureEndOfSessionDispatchHandler();
    if (eventQueue.length >= MAX_BATCH_SIZE || immediate)
        postQueuedEventsToCollector();
    else
        setTimeout(postQueuedEventsToCollector, BATCH_WAIT_TIME_MS);
}
/*
  Attempt to send any queued events to the collector service.
  Typically called in three ways -- either via a short timeout after
  dispatchEvent() was called, or else externally when a user's
  eligibility has changed (eg. through Didomi consent), or when the
  use has navigated away from the page (visibilitychange handler).
*/
export function postQueuedEventsToCollector() {
    const eventsToSend = [];
    while (eventQueue.length > 0) {
        eventsToSend.push(eventQueue.shift());
    }
    if (eventsToSend.length > 0)
        postEventsToCollector(eventsToSend);
}
/*
  Ensures an end-of-session dispatch handler exists.
  This is to catch the case where a user navigates away from the page while there were
  pending events that haven't been sent yet. It's a small window, but can
  occur if clicking a button both enqueues an event and also navigates away.
*/
function ensureEndOfSessionDispatchHandler() {
    if (!endOfSessionDispatcherCreated) {
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                postQueuedEventsToCollector();
            }
        });
        endOfSessionDispatcherCreated = true;
    }
}
/*
  Make an HTTP request to send an array of events to the collector.
  This function is private as callers are expected to use the public functions
  which test for eligibility and merge events into batches.
*/
function postEventsToCollector(events) {
    try {
        const eventUrl = tcConfigUserEventCollectorUrl() + "/v1/events";
        if (isNotOnProduction()) {
            events.forEach((event) => console.log("Dispatching user analytics event, type: " + event.eventType));
        }
        const blob = new Blob([JSON.stringify(events)], { type: "application/json" });
        navigator.sendBeacon(eventUrl, blob);
    }
    catch (err) {
        console.warn("Failed to dispatch events: " + err);
    }
}
// Checks if the environment appears to be something other than production
function isNotOnProduction() {
    const url = tcConfigUserEventCollectorUrl();
    return !url.startsWith("https://collector.theconversation.com");
}
